import React from "react";
import { ISearchField, ISearchProp } from "../Types";
import { Input, Tooltip } from "antd";

type PropType = ISearchProp & ISearchField;
export const SearchInput = (props: PropType) => {
    return <Tooltip title="我支持回车检索哦"><Input
        size={props.size}
        allowClear
        datatype="round"
        className="border-r-16"
        placeholder={props.placeholder as string}
        onPressEnter={() => props.triggerSearch ? props.handleSearch?.() : null}
        value={props.searchValues?.[props.fieldName] as string}
        onChange={(e) => {
            props.onChange?.({ [props.fieldName]: e.target.value })
            // if (props.triggerSearch) props.handleSearch?.();
        }}
        disabled={props.disabled} />
    </Tooltip>
}